import JSONAPIAdapter from '@ember-data/adapter/json-api'
import { service } from '@ember/service'
import config from 'teacher-ui-client/config/environment'
import type AuthToken from '@blakeelearning/auth/services/auth-token'
import type ReadingScalesService from 'teacher-ui-client/services/reading-scales'
import { adapterHostAndNamespace } from 'teacher-ui-client/utils/uri'

const url = new URL(config.libraryApiUrl)
export const { host, namespace } = adapterHostAndNamespace(url)
export const baseUrl = url.href

export default class BookLibraryAdapter extends JSONAPIAdapter {
  namespace = namespace

  host = host

  get baseUrl() {
    return baseUrl
  }

  @service authToken!: AuthToken

  @service readingScales!: ReadingScalesService

  // @ts-expect-error - parent defines this as a property, we override with getter
  get headers() {
    const { token } = this.authToken
    return {
      Authorization: token,
      Accept: 'application/vnd.api+json',
      accent: this.readingScales.libraryAccent,
    }
  }

  // This forms the endpoint
  pathForType(modelName: string) {
    // pluralise
    const path = super.pathForType(modelName)
    // drop the "book-library" namespace from the model name
    return path.split('book-library/')[1] || path
  }
}
